import React, { memo } from "react"
import { Grid, Tooltip } from "@material-ui/core"
import {
  InputTextMaster,
  InputOptionMaster,
  MasterButton,
} from "App/Component/ui"
import {
  defaultDateInputDisplay,
  defaultToastError,
  isNull,
} from "App/utils/helpers"

import { useSelector } from "react-redux"
import { messageError } from "utils/all"
import { SelectIcon } from "App/Assets"
import { getBpjs } from "pages/WsBridging/Peserta/Bpjs/ui/helpers"

function FormAsuransi({ formData, setFormData, handleChanges }) {
  const [loading, setLoading] = React.useState(false)
  const master = useSelector(({ master }) => master)
  const handleClickSearchSNikByNoKartu = async () => {
    if (isNull(formData.insurance_no)) {
      return defaultToastError("Harap masukkan nomor asuransi !")
    }
    setLoading(true)
    const response = await getBpjs(
      formData.insurance_no,
      defaultDateInputDisplay(formData.date, false),
    )

    if (response.state) {
      const dataRes = response.data.nik
      setFormData({
        ...formData,
        nik: dataRes,
      })
      setLoading(false)
    } else {
      setLoading(false)
      defaultToastError(response.message)
    }
  }
  return (
    <>
      <p className="fw-600 mt-1 fs-12">ASURANSI</p>
      <div>
        <Grid container spacing={1}>
          <Grid item sm={4}>
            <InputOptionMaster
              name="company_id"
              label="PERUSAHAAN"
              id="company_id"
              withSearch={true}
              data={master.perusahaan.list_select}
              value={formData.company_id}
              labelValue={formData.company_name}
              error={true}
              message={messageError.required}
              onChange={(e) => {
                if (isNull(e)) {
                  setFormData({
                    ...formData,
                    company_id: null,
                    company_name: "Pilih Perusahaan",
                  })
                } else {
                  setFormData({
                    ...formData,
                    company_id: e.value,
                    company_name: e.label,
                  })
                }
              }}
            />
          </Grid>
          <Grid item sm={4}>
            <InputOptionMaster
              name="insurance_id"
              label="ASURANSI"
              id="insurance_id"
              withSearch={true}
              data={master.asuransi.list_select}
              value={formData.insurance_id}
              labelValue={formData.insurance_name}
              error={true}
              message={messageError.required}
              onChange={(e) => {
                if (isNull(e)) {
                  setFormData({
                    ...formData,
                    insurance_id: null,
                    insurance_name: "Pilih Asuransi",
                  })
                } else {
                  setFormData({
                    ...formData,
                    insurance_id: e.value,
                    insurance_name: e.label,
                  })
                }
              }}
            />
          </Grid>

          <Grid item sm={4}>
            <div
              style={{
                display: "flex",
              }}
            >
              <InputTextMaster
                name="insurance_no"
                label="NO ASURANSI/BPJS"
                id="insurance_no"
                placeholder="No Asuransi/BPJS"
                value={formData.insurance_no}
                onChange={handleChanges("insurance_no")}
                disabled={loading}
                error={true}
                message={"Selain umum, wajib diisi"}
              />

              <Tooltip
                title={"Cari NIK dengan No. Kartu BPJS"}
                aria-label="search"
              >
                <div>
                  <MasterButton
                    type={"button"}
                    color={
                      loading ? "secondary" :
                      (formData.insurance_id === 2 &&
                        formData?.insurance_no?.length > 0)
                        ? "lightgreen"
                        : "secondary"
                    }
                    name=""
                    size="sm"
                    withIcon={true}
                    onClick={
                      loading ? "secondary" :
                      (formData.insurance_id === 2 &&
                        formData?.insurance_no?.length > 0)
                        ? () => handleClickSearchSNikByNoKartu()
                        : () => {}
                    }
                    style={{
                      marginTop: "1.5rem",
                      width: "32px",
                      height: "32px",
                    }}
                    icon={
                      <SelectIcon
                        width="16px"
                        height="16px"
                        style={{
                          marginLeft: "-0.5rem",
                        }}
                      />
                    }
                  />
                </div>
              </Tooltip>
            </div>
          </Grid>
        </Grid>
      </div>
    </>
  )
}

// const Button = React.memo(({ label, action }) => {
//   console.log(`${label} inside button render`);
//   return (
//     <div>
//       <button onClick={action}>add {label}</button>
//     </div>
//   );
// });

const MemoizeFormAsuransi = memo(FormAsuransi)

export default MemoizeFormAsuransi
